/**
 * Mini-Diagnose für Touch-/Pointer-Events auf dem Gerät. Nur sichtbar mit
 * URL-Parameter `?debug=1`. Hilft zu sehen, OB und WELCHE Events auf dem
 * iPhone ankommen, wenn die Lautstärke-Geste nicht funktioniert.
 */
export const td = {
  start: 0,
  move: 0,
  end: 0,
  cancel: 0,
  ptr: 0,
  lastDx: 0,
  vm: 0,
  vol: -1,
  note: '–',
};

export function debugEnabled(): boolean {
  try {
    return new URLSearchParams(location.search).get('debug') === '1';
  } catch {
    return false;
  }
}
